/* 🤖 this file was generated by svg-to-ts */
export const matIconReadMore: {
  name: 'read-more';
  data: string;
} = {
  name: 'read-more',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M13 7h9v2h-9zm0 8h9v2h-9zm3-4h6v2h-6zm-3 1L8 7v4H2v2h6v4z"/></svg>`
};
